import { useQuery } from '@tanstack/react-query';
import { useNotionOptionsApi } from '../components/ExpenseForm/useNotionOptionsApi';
import { useAuth } from '../contexts/AuthContext';

export const useNotionUsersQuery = () => {
  const { getUsersDatabaseId, getNotionSelectOptions } = useNotionOptionsApi();
  const { user } = useAuth();

  return useQuery({
    queryKey: ['notionUsers', user?.telegramId],
    queryFn: async () => {
      const dbIdResponse = await getUsersDatabaseId();
      
      if (!dbIdResponse.success || !dbIdResponse.databaseId) {
        throw new Error('Failed to get users database ID');
      }

      const databaseId = dbIdResponse.databaseId;
      const response = await getNotionSelectOptions(databaseId);

      if (response.success) {
        return response.options || [];
      }
      throw new Error(response.message || 'Failed to fetch Notion users');
    },
    enabled: !!user?.telegramId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};

